import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="bg-foreground-950">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs font-label uppercase tracking-[0.2em] text-primary-300">
              <span className="inline-block h-[2px] w-6 bg-primary-400" aria-hidden="true" />
              Keep Tracking
            </p>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-[30px]">
              热度会过去，时间线应该留下来
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100/80 md:text-[15px]">
              一件事从爆发到有结论，中间可能隔着几周甚至几个月。关注你感兴趣的领域，让后续自己找上门。也可以先看看我们是怎么记录一件事的。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-2-line" aria-hidden="true" />
              去找一个话题
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-shield-check-line" aria-hidden="true" />
              了解我们的原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}